//example
// sphokidz.point.10000 => 10000 Point Giá 9,900Won 
// sphokidz.point.20000 => 20000 Point Giá 20,000Won 

export const PRODUCT_ID_ANDROID = {
  8000: 'sphokidz_point_8000',
  15000: 'sphokidz_point_15000',
};

export const PRODUCT_ID_IOS = {
  8000: 'sphokidz.point.8000',
  15000: 'sphokidz.point.15000',
};